import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { StatCardData } from '../data/mediaBreakdownData';
import { Delta } from './Delta';
import { InfoTip } from './InfoTip';
import { MediaCard } from './MediaCard';

function tintColor(theme: Theme, tone: StatCardData['tone']): string {
  if (tone === 'primary') return theme.palette.primary.bg ?? theme.palette.background.paper;
  if (tone === 'success') return theme.palette.success.bg ?? theme.palette.background.paper;
  if (tone === 'error') return theme.palette.error.bg ?? theme.palette.background.paper;
  if (tone === 'warning') return theme.palette.warning.bg ?? theme.palette.background.paper;
  return theme.palette.background.paper;
}

export function StatCard({ card }: { card: StatCardData }): ReactNode {
  const tinted = card.tone !== undefined && card.tone !== 'neutral';
  return (
    <MediaCard
      sx={(theme) => ({
        p: 3,
        ...(tinted
          ? {
              background: `linear-gradient(135deg, ${tintColor(theme, card.tone)}, ${theme.palette.background.paper})`,
            }
          : {}),
      })}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'text.secondary',
          mb: 2,
        }}
      >
        {card.label}
        {card.tip && <InfoTip text={card.tip} placement={card.tipPlacement ?? 'right'} />}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography sx={{ fontSize: 28, fontWeight: 800, color: 'text.primary' }}>
          {card.value}
        </Typography>
        {card.deltaPercent !== undefined && (
          <Delta value={card.deltaPercent} invert={card.deltaInvert ?? false} fontSize={11} />
        )}
      </Box>
      {card.sub && (
        <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 1 }}>{card.sub}</Typography>
      )}
    </MediaCard>
  );
}
